import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDjjqo1vqIl78TMydiV54un33XrJ7UNaso",
  authDomain: "plumly-fe6f7.firebaseapp.com",
  projectId: "plumly-fe6f7",
  storageBucket: "plumly-fe6f7.firebasestorage.app",
  messagingSenderId: "833434359845",
  appId: "1:833434359845:web:1e2509103cea1d5e4707cc"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;